import { useState } from "react";
import { message } from "antd";

import { Dialog, DialogTitle, DialogActions } from "V2.0/common/dialog";
import { Button } from "V2.0/common/button";

import { showErrorToast } from "V2.0/utils";

export default BulkCampaignPause;

interface BulkCampaignPauseProps {
  onClose: () => void;
  bulkCampaign: any;
  onBulkCampaignPause: (
    bulkCampaignId: string,
    lifecycleCbs: {
      init: () => void;
      success: () => void;
      error: (e: any) => void;
    },
  ) => void;
}

function BulkCampaignPause(props: BulkCampaignPauseProps) {
  const { onClose, bulkCampaign, onBulkCampaignPause } = props;

  const [loading, setLoading] = useState<boolean>(false);

  const handlePause = () => {
    const init = () => {
      setLoading(true);
      message.loading(`Pausing ${bulkCampaign.name}`);
    };
    const success = () => {
      setLoading(false);
      onClose();
      message.destroy();
      message.success(`${bulkCampaign.name} Paused`);
    };
    const error = (e: any) => {
      setLoading(false);
      message.destroy();
      showErrorToast(e, `Failed to pause ${bulkCampaign.name}`);
    };

    onBulkCampaignPause(bulkCampaign._id, { init, success, error });
  };

  const title = `Pause ${bulkCampaign.name}?`;

  return (
    <Dialog
      open={true}
      onClose={onClose}
    >
      <DialogTitle>{title}</DialogTitle>
      <DialogActions>
        <Button
          outline
          onClick={onClose}
        >
          Cancel
        </Button>
        <Button
          disabled={loading}
          onClick={handlePause}
        >
          Pause
        </Button>
      </DialogActions>
    </Dialog>
  );
}
